import { HttpRequest, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import moment from 'moment';
import { SigV4CfgService } from './sigv4Cfg.service';
import sha256 from 'crypto-js/sha256';
import hmacSHA256 from 'crypto-js/hmac-sha256';
import encHex from 'crypto-js/enc-hex';

@Injectable({
    providedIn: 'root'
})
export class SigV4Service {
    private readonly region = "eu-west-1";
    private readonly service = "execute-api";

    constructor(private cfg: SigV4CfgService, private httpClient: HttpClient) {

    }

    public async signRequest(request: HttpRequest<any>): Promise<HttpRequest<any>> {
        let date = moment.utc();

        let awsHeaders = request.headers
            .set("X-Amz-Date", date.format("YYYYMMDDTHHmmss") + "Z")
            .set("Host", new URL(request.url).host);

        if (request.body) awsHeaders = awsHeaders.set("X-Amz-Content-Sha256", "");//CryptoJS.SHA256(request.body || "").toString());

        request = request.clone({
            headers: awsHeaders
        });

        let signedHeaders = this.generateSignedHeaders(request);
        let sign = await this.generateSign(request, date);
        let headerContent = `AWS4-HMAC-SHA256 Credential=${this.cfg.getCfg().accessKey}/${date.format("YYYYMMDD")}/${this.region}/${this.service}/aws4_request, SignedHeaders=${signedHeaders}, Signature=${sign}`;

        let newHeaders = request.headers
            .set("Authorization", headerContent)
            .delete("Host")
            .delete("X-Amz-Content-Sha256");

        let newRequest = request.clone({
            headers: newHeaders
        });

        return newRequest;
    }

    private generateCanonicalRequest(request: HttpRequest<any>, date: moment.Moment): string {
        let url = new URL(request.urlWithParams);
        let query = url.searchParams as URLSearchParams;
        let queryArray: string[] = [];

        query.sort();
        query.forEach((value, key) => {
            queryArray.push(`${key}=${encodeURIComponent(value)}`);
        });
        let queryString = queryArray.join("&");

        let headers = request.headers.keys()
            .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
            .map(x => `${x.toLowerCase()}:${request.headers.get(x).trim()}\n`)
            .join("");
        let signedHeaders = this.generateSignedHeaders(request);

        let body = null;
        if (request.body) {
            if (typeof request.body == "string") body = request.body;
            else body = JSON.stringify(request.body);
        }

        let str
            = request.method.toUpperCase() + "\n"
            + url.pathname + "\n"
            + queryString + "\n"
            + headers + "\n"
            + signedHeaders + "\n"
            + sha256(body || "");

        return str;
    }

    private generateSignedHeaders(request: HttpRequest<any>): string {
        let signedHeaders = request.headers.keys().map(x => x.toLowerCase()).sort().join(";");
        return signedHeaders;
    }

    private async generateSign(request: HttpRequest<any>, date: moment.Moment): Promise<string> {

        let stringToSign
            = "AWS4-HMAC-SHA256\n"
            + date.format("YYYYMMDDTHHmmss") + "Z" + "\n"
            + `${date.format("YYYYMMDD")}/${this.region}/${this.service}/aws4_request` + "\n"
            + sha256(this.generateCanonicalRequest(request, date));

        let signingResult = (await this.httpClient.get<{ sign: number[], signedString: string }>(this.cfg.getCfg().endpoint.format(
            this.cfg.getCfg().accessKey,
            date.format("YYYYMMDD"),
            this.region,
            this.service,
            stringToSign))
            .toPromise());
        let sign = encHex.parse(signingResult.sign);

        let signedString = hmacSHA256(stringToSign, sign);

        return signedString;
    }
}
